import React from "react";
import AuthRouter from "../authRouters";
import '../auth.scss';

const AuthWrapper = () => {
    return (
        <div className='auth-component'>
            <AuthRouter />
        </div>
    )
}

export default AuthWrapper;
